import React from 'react'

import { FaPhoneAlt, FaEnvelope, FaLinkedin, FaFacebook, FaTwitter, FaMapPin } from 'react-icons/fa';

const contacts = [
  {
    icon: <FaPhoneAlt size={20} />,
    text: "(310) 736-3873)",
  },
  {
    icon: <FaEnvelope size={20} />,
    text: "support@arqelio.com"
  },
  {
    icon: <FaMapPin size={20} />,
    text: "175 S 3rd St Suite 200 Columbus, OH 43215 United States"
  },
  {
    icon: <FaMapPin size={20} />,
    text: "Via Boezio Rome, 00193 Italy"
  },
  {
    icon: <FaMapPin size={20} />,
    text: "540 Sims Avenue, #03-05, Sims Avenue Centre Singapore, 387603"
  },
  {
    icon: <FaMapPin size={20} />,
    text: "Calle de VelÃ¡zquez 50, planta 5 Madrid, 28001 Spain"
  }
]

const socials = [
  {
    icon: <FaTwitter size={28} />,
    link: "https://www.twitter.com",
  },
  {
    icon: <FaLinkedin size={28} />,
    link: "https://www.linkedin.com",
  },
  {
    icon: <FaFacebook size={28} />,
    link: "https://www.facebook.com",
  }
]

const Footer = () => {
  return (
    <footer className='bg-gradient-to-r from-[#111743] to-[#191c33] text-white py-12 mt-12 shadow-[0px_-40px_50px_0px_rgba(0,0,0,0.3)]'>
      <div className='max-w-screen-xl mx-auto px-6 lg:px-12'>
        {/* Company info and logo, services, contact info, social media */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12">

          {/* Company info with logo */}
          <div className="flex flex-col items-center space-y-6">
            <div className="flex items-center space-x-4">
              <img
                src="/logo.png"
                alt="company logo"
                className="w-40"
                height={38}
                width={128}
              />
            </div>

            <h3 className="text-xl text-gray-400">
              At Arqelio, we don’t just build — we engineer possibilities.
            </h3>
            <p className="text-lg text-gray-300">
              With a foundation rooted in precision, integrity, and innovation, we deliver lasting structures, smart infrastructure, and seamless logistics that shape the future — one project at a time.
            </p>
          </div>

          {/* services */}
          <div className="flex flex-col items-center space-y-6">
            <h3 className='text-2xl font-semibold text-white'>
              Our Services
            </h3>
            <ul className="space-y-3 text-lg text-gray-400">
              {[
                "Residential Construction 🏠",
                "Commercial Construction 🏢",
                "Civil Engineering Services 🏗️",
                "Consulting Services 🧠",
                "Logistics Solutions 🚚",
                "Project Management 📊",
              ].map((service, index) => (
                <li
                  key={index}
                  className="hover:text-white font-medium transition-all duration-300"
                >
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* contact info */}
          <div className="flex flex-col items-center space-y-6">
            <h3 className='items-center text-2xl font-semibold text-white'>
              Contact / Locate us
            </h3>
            <ul className='space-y-4 text-lg text-gray-400'>
              {contacts.map((contact, index) => {
                return (
                  <li
                    key={index}
                    className="flex items-center"
                  >
                    <span className="mr-3 text-white">{contact.icon}</span>
                    <span>{contact.text}</span>
                  </li>
                )
              })}
            </ul>
          </div>

          {/* social media */}
          <div className="flex flex-col items-center space-y-6">
            <h3 className="text-2xl font-semibold text-white">
              Follow us
            </h3>

            <div className='flex space-x-6 text-gray-400'>
              {socials.map((social, index) => {
                return (
                  <a
                    key={index}
                    href={social.link}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='hover:text-white transition-all duration-300'
                  >
                    {social.icon}
                  </a>
                )
              })}
            </div>
          </div>

        </div>

        {/* Footer Bottom */}
        <div className='border-t border-gray-700 mt-12 pt-6 text-center text-lg text-gray-500'>
          <p>
            © 2025 Arqelio. All rights reserved. |
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer